import React from 'react'
import Modal from 'react-bootstrap-modal'

const NotifyModal = ({ onYes, onNo, onClose }) => {
  return (
    <Modal container={document.body} show={true} onHide={onClose} sm dialogClassName='notify-modal'>
      <Modal.Header closeButton>
        <Modal.Title>&nbsp;</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 className='text-center'>Do you want players to be notified about the changes made to this game?</h5>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={onYes} className='btn btn-success'>Yes</button>
        <button onClick={onNo} className='btn btn-default'>No</button>
      </Modal.Footer>
    </Modal>
  )
}

export default NotifyModal
